import {
    Component,
    OnInit,
    ViewEncapsulation,
    Input,
    AfterViewInit,
    ChangeDetectorRef,
    OnDestroy
} from '@angular/core';
import { MagazineService } from '../../interfaces/magazine-service.interface';
import { IAdditionalInfoContainerResult, IAdditionalInfoResult } from '../../models/magazine-result';
import { UiHelperService, PrebootService } from 'core-max-lib';
import {
    ActivatedRoute,
    Params,
    Router,
    NavigationEnd,
    NavigationStart,
    RouterEvent
} from '@angular/router';
import { Location } from '@angular/common';
import { Subscription } from 'rxjs';

declare var $: any;

@Component({
    selector: 'lib-more-info',
    templateUrl: './more-info.component.html',
    styleUrls: ['./more-info.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class MoreInfoComponent implements OnInit, AfterViewInit, OnDestroy {
    private routerEventSubscription: Subscription;

    constructor(
        private uiHelper: UiHelperService,
        private magazineService: MagazineService,
        private location: Location,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private prebootSvc: PrebootService,
        private changeDetector: ChangeDetectorRef
    ) {
        this.router.routeReuseStrategy.shouldReuseRoute = function () {
            return false;
        };
        this.routerEventSubscription = this.router.events.subscribe(
            (event: RouterEvent) => {
                if (event instanceof NavigationEnd) {
                    this.router.navigated = false;
                }
            }
        );
    }

    @Input() content: IAdditionalInfoContainerResult;

    slideConfig = {
        infinite: false,
        centerMode: false,
        variableWidth: true,
        variableHeight: true,
        // slidesToShow: 3,
        slidesToScroll: 1,
        speed: 200,
        swipeSpeed: 200,
        arrows: false,
        mobileFirst: true,
        rtl: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    arrows: true,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 320,
                settings: {
                    variableWidth: false,
                    variableHeight: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false
                }
            }
        ]
    };

    ngOnDestroy() {
        if (this.routerEventSubscription) {
            this.routerEventSubscription.unsubscribe();
        }
        if (this.uiHelper.isBrowser) {
            $('.more-info .more-info-slider').slick('unslick');
        }
    }

    ngOnInit() {
        if (this.uiHelper.isBrowser) {
            $('.more-info .more-info-slider').on('init', function (
                event,
                slick
            ) {
                slick.slickGoTo(0);
                this.completeSlickInit();
            }.bind(this));
        }
    }

    navigateTo(url: string, isFromArticle: boolean, additionalInfo: IAdditionalInfoResult, e) {
        if (isFromArticle && additionalInfo) {
            this.magazineService.pushToGtm('article – ' + this.content.additionalInfoCategoryName + ' - ' + additionalInfo.additionalInfoTitle, 'Click on next article – ' + additionalInfo.additionalInfoTitle);
            url += '?sourceGA=MoreArticles';
        }
        this.router.navigateByUrl(url);
        e.preventDefault();
        // this.router
        //     .navigateByUrl('/', { skipLocationChange: true })
        //     .then(() => {
        //         this.router.navigateByUrl(url);
        //     });
        // this.location.replaceState(url);
    }

    ngAfterViewInit(): void {
        if (this.uiHelper.isBrowser) {
            this.prebootSvc.transitionComplete.subscribe(stable => {
                if (stable) {
                    $('.more-info .more-info-slider').slick(this.slideConfig);
                    this.completeSlickInit();
                }
            });
        }
    }

    completeSlickInit() {
        setTimeout(() => {
            if (this.uiHelper.detectIE()) {
                const resizeEvent = window.document.createEvent('UIEvents');
                resizeEvent.initEvent('resize', true, false);
                window.dispatchEvent(resizeEvent);
            } else {
                window.dispatchEvent(new Event('resize'));
            }
        }, 250);
    }
}
